import { placesEnvironment } from '../places-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placeDetailsSchema } from '../schemas/place-details.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get an array of place details by placeIds
 * HARD LIMIT: 50
 * @param placeIds Array of trimblePlaceIds
 * @returns An array of place details
 */
export function postPlacesPlaceDetailsBulk(
  this: unknown,
  request: {
    placeIds: string[];
    getSites?: boolean;
  }
) {
  const params =
    typeof request.getSites === 'undefined'
      ? ''
      : `?${new URLSearchParams([['getSites', String(request.getSites)]]).toString()}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${placesEnvironment.resolve(this).placesPlaceDetailsBulkUrl}${params}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(request.placeIds),
        }
      )
    )
  ).pipe(selectData(z.array(placeDetailsSchema)));
}
